export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL'
export const GET_PROFILE_CLEAR_DATA = 'GET_PROFILE_CLEAR_DATA'
